import { graphql } from '@api/generated';

/**
 * Subscription for the current authenticated user's changes.
 * This is a NOTIFICATION-ONLY subscription - it signals that the user
 * data has changed, triggering a fetch of the latest data via getCurrentUser().
 *
 * This subscription filters by userId on the server side to avoid receiving
 * updates for all users in the contact center.
 */
export const currentUserChangedSubscription = graphql(`
  subscription currentUserChanged($actions: [ChangeAction!]!, $userId: ID!) {
    userChanged(actions: $actions, userId: $userId) {
      action
      data {
        id
      }
    }
  }
`);
